import React, { useState, useEffect } from 'react';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import * as Picklist from './../Picklist';
import * as Common from './../Common';
import Dialog from '../Dialog';
import DatePicker from 'react-datepicker';
import $ from "jquery";
import { useNavigate } from 'react-router-dom';

const Rep_principle_report = () => {
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');
    const [GenerateType, setGenerateType] = useState("V");
    const [filterLocationType, setFilterLocationType] = useState("A");
    const [filterLocation, setFilterLocation] = useState(null);
    const [locationCode, setLocationCode] = useState(0);
    const [masterPrinciple, setMasterPrinciple] = useState(null);
    const [filterMasterPrinciple, setFilterMasterPrinciple] = useState('A');
    const [filterFromDate, setFilterFromDate] = useState(new Date());
    const [filterToDate, setFilterToDate] = useState(new Date());
    const [principleCode, setPrincipleCode] = useState(0);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'PRINCIPLE_REPORT'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleChangeLocation = (value) => {
        setFilterLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        sessionStorage.activeBranch = loc[1];
    }

    const handleLocationType = (e) => {
        setFilterLocationType(e.target.value);
        if (e.target.value === 'A') {
            setLocationCode(0);
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
        }
    }

    const handleMasterPrinciple = (value) => {
        setMasterPrinciple(value);
        console.log("Priciple value is ", value);
        const prncl = value.id.split('^');
        setPrincipleCode(prncl[1]);
        console.log("Priciple value is ", prncl[1]);
    }

    const handleGenerate = () => {
        $(".loader").show();

        if (!Common.validateFinYear(Common.dateYMD(filterFromDate), Common.dateYMD(filterToDate))) {
            $(".loader").hide();
            setMsgText("Date should be within financial year");
            setMsgBox(true);
            return;
        } else if (filterFromDate > filterToDate) {
            $(".loader").hide();
            setMsgText("From Date should be less than To Date");
            setMsgBox(true);
            return;
        }

        var msg = [], i = 0;
        if ((filterLocationType === 'O' && filterLocation === null) || (filterMasterPrinciple === 'O' && masterPrinciple === null) || filterFromDate == "" || filterToDate == "") {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((filterLocationType === 'O' && filterLocation === null) ? "Select Location." : '')
            msg[i++] = (((filterMasterPrinciple === 'O' && masterPrinciple === null)) ? "Select Master Principle." : '');
            msg[i++] = (filterFromDate == "" ? "From Date." : '');
            msg[i++] = (filterToDate == "" ? "To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                generateType: GenerateType,
                filterLocationType: filterLocationType,
                location: locationCode,
                filterMasterPrinciple: filterMasterPrinciple,
                principleCode: principleCode,
                fromDate: Common.dateYMD(filterFromDate),
                toDate: Common.dateYMD(filterToDate),
            };
            if (GenerateType === 'D') {
                Common.callDownloadApiPost1(Common.apiPrincipleReport, "post", [sid, "getData", JSON.stringify(obj)], result => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else {
                Common.callApi(Common.apiPrincipleReport, [sid, "getData", JSON.stringify(obj)], result => {
                    var newWindow = window.open();
                    newWindow.document.write(result);
                    $(".loader").hide();
                });

            }
        }
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Principle Report</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterLocationType} onChange={handleLocationType}
                                required>
                                <option value="O">One</option>
                                <option value="A">All</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterLocationType === 'O' ? <>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={filterLocation}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={Picklist.fetchLocationAllowedPicklist}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleChangeLocation}
                                    isDisabled={branchDisable === "true"}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col></> : null}
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Master Principle Type<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterMasterPrinciple} onChange={(e) => setFilterMasterPrinciple(e.target.value)}
                                required>
                                <option value="O">One</option>
                                <option value="A">All</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterMasterPrinciple === 'O' ?
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Master Principle<span className='colorThemeRed'>*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={masterPrinciple}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={Picklist.fetchPrincipleModulePicklist}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleMasterPrinciple}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col>
                        : null}
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                            <DatePicker className="form-control"
                                selected={filterFromDate}
                                onChange={(date) => setFilterFromDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                            <DatePicker className="form-control"
                                selected={filterToDate}
                                onChange={(date) => setFilterToDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={GenerateType} onChange={e => setGenerateType(e.target.value)}
                                required>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_principle_report;
